import {ReactNode} from "react";
import {Accordion} from "@mantine/core";
import {RenderableDocument, DibJsonNode} from "../../types";
import classes from "./xbox.module.css";

type Props = {
    node: DibJsonNode;
    children: ReactNode[];
    map: RenderableDocument;
};

export const Xbox = ({node, children, map}: Props) => {
    const attrs = node.element?.attributes;
    const id = attrs?.id ?? "xbox";
    const kind = node.kind ?? "";

    // Check if the first child element is a figcaption
    const firstChildRef = node.element?.children?.[0];
    const firstChildId =
        firstChildRef && "id" in firstChildRef ? firstChildRef.id : null;
    const hasCaption =
        firstChildId !== null &&
        map.elements[firstChildId]?.name === "figcaption";

    const title = hasCaption ? children[0] : null;
    const body = hasCaption ? children.slice(1) : children;

    // Default expanded if kind is "xbox open" or data-defaultopen is "open"
    const defaultOpen = attrs?.["data-defaultopen"] === "open";

    return (
        <Accordion
            variant="contained"
            radius="sm"
            defaultValue={defaultOpen ? id : undefined}
            classNames={{
                root: classes.root,
                item: classes.item,
                control: classes.control,
                label: classes.label,
                panel: classes.panel,
                content: classes.content,
            }}
        >
            <Accordion.Item value={id}>
                <Accordion.Control>{title}</Accordion.Control>
                <Accordion.Panel>{body}</Accordion.Panel>
            </Accordion.Item>
        </Accordion>
    );
};
